import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gdp-marketing-main',
  templateUrl: './marketing-main.component.html',
  styleUrls: ['./marketing-main.component.scss']
})
export class MarketingMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
